import { fetchJson } from 'utils/fetchJson/fetchJson';
import { mapChargeDecisionRequestBody, mapChargeRequestBody } from './mapper';
import type {
  ChargeDecisionRequestBody,
  ChargeDecisionResponse,
  ChargeRequestBody,
  ChargeResponse,
} from './models';

const cardOnFile = {
  chargeDecision: async (attrs: ChargeDecisionRequestBody) => {
    return fetchJson<ChargeDecisionResponse>('/card_on_file/charge_decision', {
      method: 'POST',
      body: JSON.stringify(mapChargeDecisionRequestBody(attrs)),
    });
  },

  charge: async ({ accessToken, ...attrs }: ChargeRequestBody) => {
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(mapChargeRequestBody(attrs)),
    };
    const options = {} as Record<string, unknown>;

    return fetchJson<ChargeResponse>('/card_on_file/charge', {
      ...requestOptions,
      ...options,
    });
  },
};

export { cardOnFile };
